import { render, staticRenderFns } from "./promoMemberTab.vue?vue&type=template&id=dcb325b4&lang=pug"
import script from "./promoMemberTab.vue?vue&type=script&lang=js"
export * from "./promoMemberTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports